<template>
  <div style="width: 100%;overflow: hidden;height: 800px;">
    <!--添加通知信息-->
    <div class="logindiv" id="AddForm_tree">
      <div class="loginForm">
        <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;" v-if="ADD_OR_UPDATE">
            添加页签
          </span>
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;" v-else>
            添加页签
          </span>
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
            <a href="javascript:;" @click="close">
              <i class="el-icon-close"></i>
            </a>
          </span>
        </div>
        <!-- 添加 -->
        <div style="width: 300px;margin: 0 auto;" v-if="ADD_OR_UPDATE">
          <el-form :model="AddForm" ref="AddForm" style="margin-top: 10px;">
            <el-form-item>
              <el-radio-group v-model="AddForm.type" @change="radiochange">
                <el-radio :label="1">内部地址</el-radio>
                <el-radio :label="2">外部地址</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.icon" placeholder="页签图标">
                <template slot="append"><i :class="AddForm.icon" style="font-size: 20px;"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.name" placeholder="页签名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.url_name" :disabled="url_name_type" placeholder="关联地址"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.url" placeholder="外部引用地址"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 100%;" v-model="AddForm.tree_type" placeholder="请选择页签层次">
                <el-option
                  v-for="item in TreeTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="权限信息">
              <br>
              <div style="border: 0.05rem solid #aaa;overflow-y:auto;">
                <div style="margin-left: 15px;text-align: left;">
                  <el-checkbox-group v-model="AddForm.admin_type" :min="1">
                    <el-checkbox v-for="cc in Admin_typeList" :label="cc.type" :key="cc.id">{{cc.type_name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 300px;" @click="ADDTree()">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 修改 -->
        <div style="width: 300px;margin: 0 auto;" v-else>
          <el-form :model="AddForm" ref="AddForm" style="margin-top: 10px;">
            <el-form-item>
              <el-radio-group v-model="AddForm.type" @change="radiochange">
                <el-radio :label="1">内部地址</el-radio>
                <el-radio :label="2">外部地址</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.icon" placeholder="页签图标">
                <template slot="append"><i :class="AddForm.icon" style="font-size: 20px;"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.name" placeholder="页签名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.url_name" :disabled="url_name_type" placeholder="关联地址"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="text" v-model="AddForm.url" placeholder="外部引用地址"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 100%;" v-model="AddForm.old_id" placeholder="请选择页签层次">
                <el-option
                  v-for="item in treelists"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 100%;" v-model="AddForm.tree_type" placeholder="请选择页签层次">
                <el-option
                  v-for="item in TreeTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="权限信息">
              <br>
              <div style="border: 0.05rem solid #aaa;overflow-y:auto;">
                <div style="margin-left: 15px;text-align: left;">
                  <el-checkbox-group v-model="AddForm.admin_type" :min="1">
                    <el-checkbox v-for="cc in Admin_typeList" :label="cc.type" :key="cc.id">{{cc.type_name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 300px;" @click="ADDTree()">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
        <br>
      </div>
    </div>

    <div class="box">
      <div class="box-title">
        树形管理
      </div>
      <div class="box-content" >
          <el-tree
            :data="data"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => append(data)">
                  添加
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => updateTree(data)">
                  修改
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => remove(node, data)">
                  删除
                </el-button>
              </span>
            </span>
          </el-tree>
        </div>
    </div>
    <div class="box" style="margin-left: 0.5%;">
      <div class="box-title">
        树形展示
      </div>
      <div class="box-content" >
        <el-tree :data="data" :default-expand-all="true">
          <span slot-scope="{ node, data }">
            <span><i :class="data.icon"></i></span>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
  let id = 1000;
  import {commonAPI} from '@/api/commonAPI'
export default {
  data () {
    return {
      treeLists:[],
      ADD_OR_UPDATE:true,
      Admin_typeList:'',
      TreeTypeList:'',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      data: [],
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
        admin_type:'',
        admin_id:'',
      },
      TreeUP:{
        admin_id:'',
        admin_type:'-99',
      },
      AddForm:{
        name:'',//
        icon:'',//
        url_name:'',//
        tree_type:'',
        admin_type:[],//
        old_id:'',//
        type:1,
        url:'',
      },
      url_name_type:false,
      formInline: {
        type_name:'',
        pageNum:1,
        pageSize:99
      },
    }
  },
  //页面开启时执行
  mounted(){
    this.judgeLogin();
    this.queryTree();
    this.queryTree_typelist();
    this.getData_Admin_type();
  },
  //方法
  methods: {
    //内外部地址切换
    radiochange(){
      if(this.AddForm.type==2){
        this.url_name_type=true;
        this.AddForm.url_name="IframeVue";
      }else{
        this.url_name_type=false;
      }
    },
    //添加
    ADDTree(){
      if(this.AddForm.name.length<=0){
        this.$message({
          message: '页签名称不能为空',
          type: 'error'
        });
        return false;
      }
      if(this.AddForm.tree_type.length<=0){
        this.$message({
          message: '页签层次不能为空',
          type: 'error'
        });
        return false;
      }
      if(this.AddForm.admin_type.length<=0){
        this.$message({
          message: '页签权限不能为空',
          type: 'error'
        });
        return false;
      }
      let admin_type="";
      for(let i=0;i<this.AddForm.admin_type.length;i++){
        admin_type=admin_type+"/"+this.AddForm.admin_type[i]
      }
      admin_type=admin_type+"/";
      this.AddForm.admin_type=admin_type;
      this.AddForm.admin_id=this.$store.state.a_id;
      //
      let url="";
      if(this.ADD_OR_UPDATE){
        url="addTree";
      }else{
        url="updateTree";
      }
      //
      commonAPI(url,this.AddForm).then(res => {
        let data = res.data;
        //console.log(res.data.rows);
        if(this.response.response(data)){
          this.queryTree();
          this.close();
        }
      }).catch(error=>{
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: error.message,
          position: 'bottom-right',
          type: 'error'
        });
        })
    },
    //
    queryTree(){
      this.TreeUP.admin_id=this.$store.state.a_id;
      commonAPI('queryTreeList',this.TreeUP).then(res => {
        let data=res.data.data.rows
        //console.log(res.data.data.rows);
        this.treelists=data;
        this.showTree(data);
      }).catch(error=>{
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: error.message,
          position: 'bottom-right',
          type: 'error'
        });
        })
    },
    //查询权限信息
    getData_Admin_type() {
        commonAPI('queryAdmin_type',this.formInline).then(res => {
          this.Admin_typeList = res.data.data.rows;
          //console.log(res.data.rows);
        })
    },
    //
    queryTree_typelist(){
      commonAPI('queryTreeTypeList','1').then(res => {
        let data=res.data.data.rows
        //console.log(res.data.data.rows);
        this.TreeTypeList=data;
      }).catch(error=>{
        this.$notify({//这里采用element ui的一个错误显示效果模板
          title: '提示',
          message: error.message,
          position: 'bottom-right',
          type: 'error'
        });
        })
    },
    //
    showTree(data){
      let list=[];
      let NewC = null;
      let newC = null;
      let newChild = null;
      //
      NewC = { id: "", label: '根节点', children: [], admin_type: "//",icon:'el-icon-menu' };
      //
      for(let cc=1;cc<=2;cc++){
        for(let i=0;i<data.length;i++){
          if(data[i].tree_type*1==cc){
            newC = { id: data[i].id,old_id: data[i].old_id, label: data[i].name, children: [], admin_type: data[i].admin_type,icon:data[i].icon,url_name:data[i].url_name,tree_type:data[i].tree_type,url:data[i].url };
            for(let j=0;j<data[i].list.length;j++){
              if(data[i].list.length>0){
                newChild = { id: data[i].list[j].id,old_id: data[i].list[j].old_id, label: data[i].list[j].name, children: [], admin_type: data[i].list[j].admin_type,url_name:data[i].list[j].url_name,tree_type:data[i].list[j].tree_type,url:data[i].url };
                if (!newC.children) {
                  this.$set(newC, 'children', []);
                }
                newC.children.push(newChild);
              }
            }
            NewC.children.push(newC);
          }
        }
      }
      list.push(NewC);
      this.data=list;
    },
    //
    //打开通知详情
    openUpdate(data){
      if(data.id!=null||data.id!=""){
        this.AddForm.old_id=data.id;
      }
      let admin_typelist=[];
      let admin_type=data.admin_type.split("/");
      for(let i=0;i<admin_type.length;i++){
        if(admin_type[i]!=""){
          admin_typelist.push(admin_type[i]);
        }
      }
      this.AddForm.admin_type=admin_typelist;
      if(!this.ADD_OR_UPDATE){
        this.AddForm.id=data.id
        this.AddForm.old_id=data.old_id;
        this.AddForm.name=data.label;
        this.AddForm.tree_type=data.tree_type;
        this.AddForm.url_name=data.url_name;
        this.AddForm.icon=data.icon;
        this.AddForm.url=data.url;
      }
      //console.log(admin_typelist);
      document.getElementById('AddForm_tree').style.display='block';
      document.getElementById('zhedang').style.display='block';
    },
    close(){
      this.AddForm.id="";
      this.AddForm.name="";
      this.AddForm.tree_type="";
      this.AddForm.admin_type=[];
      this.AddForm.url_name="";
      this.AddForm.icon="";
      this.AddForm.old_id="";
      this.AddForm.url="";
      document.getElementById('AddForm_tree').style.display='none';
      document.getElementById('zhedang').style.display='none';
    },
    //
    append(data) {
      this.ADD_OR_UPDATE=true;
      this.openUpdate(data);
    },
    //
    updateTree(data) {
      console.log(data);
      this.ADD_OR_UPDATE=false;
      this.openUpdate(data);
    },
    //
    remove(node, data) {
      this.$confirm('此操作将永久删除此项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let admin_id=this.$store.state.a_id;
        data.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteTree',data).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.queryTree();
          }
        }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
        })
      })
    },
    //获取信息方法
    judgeLogin(){
        this.AdminInfor.id=this.$store.state.a_id;
        this.AdminInfor.type=this.$store.state.a_type;
      },
    },
}
</script>

<style scoped>
  .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .box{
      width: 49%;
      float: left;
      border: 1px solid #ddd;
      height: 770px;
      overflow-y: auto;
    }
    .box-title{
      margin-left: 3%;
      margin-right: 3%;
      margin-bottom: 20px;
      text-align: center;
      margin-top: 10px;
      font-size: 25px;
    }
    .box-content{
      margin-left: 3%;margin-right: 3%;margin-bottom: 10px;
    }
    /**滚动条样式*/
    .box::-webkit-scrollbar{
      width: 5px;
    }
    .box::-webkit-scrollbar-thumb{
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #535353;
    }
    .box::-webkit-scrollbar-thumb{
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      border-radius: 10px;
      background: #EDEDED;
    }
    /**登录框架*/
    .logindiv{
      position: fixed;
      top: 17%;
      left:0;
      right:0;
      bottom: 0;
      margin:0 auto;
      padding: 20px;
      border: 0px solid #ddd;
      z-index:2002;
      overflow: auto;
      text-align: center;
      display: none;
    }
    .loginForm{
      margin: 0 auto;
      width: 550px;
      background-color: #fff;
      -webkit-box-shadow: #333 0px 5px 5px;
      -moz-box-shadow: #333 0px 5px 5px;
      box-shadow: #333 0px 5px 5px;
    }
    .loginForm a{
      color: #fff;
    }
    .loginForm a:hover{
      color: #d6d6d6;
    }
</style>



// WEBPACK FOOTER //
// src/admin/views/system/TreeManage.vue